import React, { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom'; // تم تعديل الاستيراد ليشمل `useNavigate`
import './App.css';
import Layout from './layout/layout';

import Login from './pages/dashoard/login';
import Dashboard from './pages/dashoard/Dashboard';
import Maintenance from './pages/dashoard/Maintenance/Maintenance';
import Analysis from './pages/dashoard/Analysis/Analysis';
import Units from './pages/dashoard/Units/Units';
import Payment from './pages/dashoard/Payment/Payment';
import ChangePassword from './pages/dashoard/ChangePassword/ChangePawword';
import Profile from './pages/dashoard/Profile/Profile';

import {jwtDecode} from 'jwt-decode';
import { refreshtoken } from './components/Apis';
import Contracts from './pages/dashoard/contract/Contracts';
import Unit from './pages/dashoard/Units/unit';
import Forget from './pages/dashoard/forget';
import Create from './pages/create';
import Otpverify from './pages/otpverify';
import Chat from './pages/dashoard/Chat/Chat';
import Reservation from './pages/dashoard/Reservation/Reservation';
import Notification from './pages/dashoard/Notification/Notification';
import UnitSteps from './pages/dashoard/Units/AddunitOld';
import Editnewunit from './pages/dashoard/Units/EditNewUnit';
// import Reservation from './pages/dashoard/Reservation/reservation/index'
// import NewReservation from './pages/dashoard/Reservation/reservation/index';

const checkTokenExpiration = async (navigate) => {
  const currentPath = window.location.pathname; // الحصول على المسار الحالي

  // استثناء الصفحات غير المحمية مثل `/forget`
  if (currentPath === '/forget'|| currentPath === '/create' || currentPath === '/' ) return;

  const token = localStorage.getItem('token');

  if (!token) {
    navigate('/'); // توجيه المستخدم إلى صفحة تسجيل الدخول
    return;
  }

  try {
    const decodedToken = jwtDecode(token);
    const expirationTime = decodedToken.exp * 1000; // وقت انتهاء التوكن
    const currentTime = Date.now();

    const timeRemaining = expirationTime - currentTime;

    if (timeRemaining <= 0) {
      navigate('/'); // التوكن منتهي الصلاحية، توجه إلى صفحة تسجيل الدخول
    } else {
      const refreshTime = timeRemaining - 10 * 60 * 1000; // تحديث التوكن قبل 10 دقائق
      if (refreshTime <= 0) {
        await refreshtoken(); // تحديث التوكن مباشرةً
      } else {
        setTimeout(async () => {
          await refreshtoken();
        }, refreshTime);
      }
    }
  } catch (error) {
    console.error('Invalid token format:', error);
    navigate('/'); // خطأ في التوكن، توجه إلى صفحة تسجيل الدخول
  }
};


function App() {
  const navigate = useNavigate(); // استخدام useNavigate للتنقل بين الصفحات

  useEffect(() => {
    checkTokenExpiration(navigate);
  }, [navigate]);

  return (
    <>
      <Routes>
        <Route path='/' element={<Login />} />
        <Route path='/forget' element={<Forget />} />
        <Route path='/create' element={<Create />} />
        <Route path='dashboard' element={<Layout children={<Dashboard />} />} />
        <Route path='maintenance' element={<Layout children={<Maintenance />} />} />
        <Route path='analysis' element={<Layout children={<Analysis />} />} />
        <Route path='units' element={<Layout children={<Units />} />} />
        <Route path='Addunits' element={<Layout children={<UnitSteps />} />} />
        <Route path='Editnewunit' element={<Layout children={<Editnewunit />} />} />
        {/* <Route path='/unit/reservation' element={<Layout children={<NewReservation />} />} /> */}

        <Route path='/unit/:id' element={<Layout children={<Unit />} />} />
        <Route path='payment' element={<Layout children={<Payment />} />} />
        <Route path='changepassword' element={<Layout children={<ChangePassword />} />} />
        <Route path='profile' element={<Layout children={<Profile />} />} />
        <Route path='contract' element={<Layout children={<Contracts />} />} />
        <Route path='chat' element={<Layout children={<Chat/>} />} />
        <Route path='notification' element={<Layout children={<Notification/>} />} />
        <Route path='reservation' element={<Layout children={<Reservation/>} />} />
      </Routes>
    </>
  );
}

export default App;
